import {NullAsDefault} from "views/Shared";
import Loadable from 'react-loadable'

export default Loadable({
  loader: () =>
    import('./DocumentEditor'),
  loading: NullAsDefault
})
